import { call, put, takeLatest } from 'redux-saga/effects';
import {
  USER_INPUT_QUERY_START,
  UserInputQueryStartAction,
  getUserInputQuerySuccessAction,
  getUserInputQueryFailedAction,
} from '../actions/UserInputAction';
import ApiUtil from 'src/utils/ApiUtil';

export function* getUserInput(action: UserInputQueryStartAction) {
  try {
    const parameters: any = {
      asin: action.asin,
      mSku: action.mSku,
      countryCode: action.countryCode,
    };
    // @ts-expect-error
    const response = yield call(
      ApiUtil.callApiWithTimeout,
      'getuserinput',
      parameters,
    );

    yield put(getUserInputQuerySuccessAction(response));
  } catch (error) {
    console.error('Call API getuserinput error' + error);
    yield put(getUserInputQueryFailedAction());
  }
}

export default function* userInputQuery() {
  yield takeLatest(USER_INPUT_QUERY_START, getUserInput);
}
